import { useNavigate } from "react-router";
import { toast } from "react-toastify";
import config from "../../config";
import Cookies from "js-cookie";
import { resetState as resetSentRfqState } from "../../redux/slice/sentRfq";
import { resetState as resetReceivedRfqState } from "../../redux/slice/receivedRfq";
import { resetCashWallet } from "../../redux/slice/cashWallet";
import { resetCreditWallet } from "../../redux/slice/creditWallet";
import { resetAddress } from "../../redux/slice/address";
import { resetState as resetSentOrder } from "../../redux/slice/sentOrder";
import { resetState as resetReceivedOrder } from "../../redux/slice/receivedOrder";
import { resetCommodityProduct } from "../../redux/slice/commodityProduct";
import { resetTransporterProduct } from "../../redux/slice/transporterProduct";
import { resetTransporterOrder } from "../../redux/slice/transporterOrder";
import { useDispatch } from "react-redux";
import { useCallback } from "react";
import notificationService from "../../services/notificationService";

const useLogout = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const logout = useCallback(
    async (showToast = false) => {
      // Clean up notifications before clearing user data
      try {
        await notificationService.cleanupOnLogout();
        console.log('Notifications cleaned up on logout');
      } catch (notificationError) {
        console.error('Error cleaning up notifications on logout:', notificationError);
        // Don't block logout process if notification cleanup fails
      }

      Cookies.remove("bz_utkn");
      Cookies.remove("bz_uinf");
      config.token = null;
      config.user = null;
      dispatch(resetSentRfqState());
      dispatch(resetReceivedRfqState());
      dispatch(resetCashWallet());
      dispatch(resetCreditWallet());
      dispatch(resetAddress());
      dispatch(resetSentOrder());
      dispatch(resetReceivedOrder());
      dispatch(resetCommodityProduct());
      dispatch(resetTransporterProduct());
      dispatch(resetTransporterOrder());
      if (showToast) {
        toast.success("You are logged out!!", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      }
      setTimeout(() => {
        navigate("/");
      }, 1000);
    },
    [dispatch, navigate]
  );
  return logout;
};

export default useLogout;
